import { ExportColumn } from '../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: '',
    type: 'text',
    width: 50,
  },
  {
    key: 'totalInventory',
    header: 'Finished Goods Inventory',
    type: 'money',
  },
  {
    key: 'totalOnsite',
    header: 'Onsite',
    type: 'money',
  },
  {
    key: 'totalInternal',
    header: 'Internal',
    type: 'money',
  },
  {
    key: 'totalExternal',
    header: 'External',
    type: 'money',
  },
  {
    key: 'strategyComment',
    header: 'Commentary',
    type: 'text',
    width: 150,
    placeholder: 'Not Provided',
  },
];
